import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL PAYMENTS -------------------- */
export const AllPaymentsThunk = createAsyncThunk(
  "payments/AllPaymentsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/payments/list?payment_status=completed`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch payments"
      );
    }
  }
);

/* -------------------- GET SINGLE PAYMENT -------------------- */
export const GetSingleInvoiceThunk = createAsyncThunk(
  "payments/GetSingleInvoiceThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/payments/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch payment details"
      );
    }
  }
);

/* -------------------- ADD PAYMENT -------------------- */
export const AddInvoiceThunk = createAsyncThunk(
  "payments/AddInvoiceThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/payments/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add invoice");
    }
  }
);

/* -------------------- UPDATE PAYMENT -------------------- */
export const UpdateInvoiceThunk = createAsyncThunk(
  "payments/UpdateInvoiceThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const payload = { ...formData, uuid };
      const response = await axios.post(`/api/payments/update`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update invoice"
      );
    }
  }
);

/* -------------------- DELETE PAYMENT -------------------- */
export const DeleteInvoiceThunk = createAsyncThunk(
  "payments/DeleteInvoiceThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/payments/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete invoice"
      );
    }
  }
);
